/* @ts-self-types="./fuzzy_search.d.ts" */

import * as wasm from "./fuzzy_search_bg.wasm";
import { __wbg_set_wasm } from "./fuzzy_search_bg.js";
__wbg_set_wasm(wasm);
wasm.__wbindgen_start();
export {
    AirportIndex, search_airport
} from "./fuzzy_search_bg.js";
